import * as React from 'react'
import { IconButton, Icon, Popover, Whisper, Panel } from 'rsuite'

export default function CustomIconMessageInfo(props) {
  const Speaker = ({ title, content, content2, contents, ...props }) => {
    return (
      <Popover title={title} {...props}>
        <Panel style={{ backgroundColor: '#faebd7' }}>
          <p style={{ fontSize: '1rem' }}>{content}</p>
          <p style={{ fontSize: '1rem' }}>{content2}</p>
          {contents &&
            contents.map((item, index) => {
              return (
                <p style={{ fontSize: '1rem', marginBottom: 10 }} key={index}>
                  {item}
                </p>
              )
            })}
        </Panel>
      </Popover>
    )
  }

  return (
    <div style={{ marginBottom: 3, marginTop: 5 }}>
      <Whisper
        trigger="click"
        placement={'right'}
        speaker={
          <Speaker
            key={props.key}
            title={props.title}
            content={props.content}
            content2={props.content2}
            contents={props.contents}
          />
        }
      >
        <IconButton color="orange" icon={<Icon appearance="ghost" icon="info" />} />
      </Whisper>
      <span style={{ color: 'orange' }}> คำอธิบายการกรอกข้อมูล</span>
    </div>
  )
}
